// extracted by mini-css-extract-plugin
export var buttonContainer = "carousel-module--button-container--5OiYI";
export var carousel = "carousel-module--carousel--tsLVL";
export var carouselDeck = "carousel-module--carousel-deck--3qHlc";
export var carouselItem = "carousel-module--carousel-item--kQafv";
export var carouselTitle = "carousel-module--carousel-title--SYyTZ";
export var container = "carousel-module--container--prGl4";
export var embedLink = "carousel-module--embed-link--wxZwH";
export var overlay = "carousel-module--overlay--gzbhL";
export var overlayLeft = "carousel-module--overlay-left---CsN2";
export var scrollContainer = "carousel-module--scroll-container--NQ+Xl";